import { Redirect, Route, Switch } from 'react-router-dom';
import { useMemo } from 'react';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from './utils/AsyncComponentErrorHandler';
// @ts-expect-error file not converted to TS yet
import AsyncComponentLoading from './components/AsyncComponentLoading';
// @ts-expect-error file not converted to TS yet
import { LegacyRoutes } from './legacyRoutes';
import { useMobileReauthCookie } from './hooks/useMobileReauthCookie';
import { MobileLoginContext } from './context/MobileLoginContext';
import { getIsUngatedForLoginV4 } from './utils/cookies';
import { getReauthCookieValue } from './utils/cookies';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Login = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-LoginV4" */'./components/Login').catch(AsyncComponentErrorHandler('chunk-LoginV4')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const PasswordResetPageVariant = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-passwordReset" */'./components/PasswordReset/PasswordResetPageVariant').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-passwordReset')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const RequestResetEmailPageVariant = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-requestResetEmail" */'./components/RequestResetEmail/RequestResetEmailPageVariant').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-requestResetEmail')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorAuthPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-TwoFactorAuthPage" */'./components/TwoFactorAuth/TwoFactorAuthPage').catch(AsyncComponentErrorHandler('chunk-TwoFactorAuthPage')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorRequestRecoveryNametag = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-TwoFactorRequestRecoveryNametag" */'./components/TwoFactorRequestRecovery/TwoFactorRequestRecoveryNametag').catch(AsyncComponentErrorHandler('chunk-TwoFactorRequestRecoveryNametag')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const TwoFactorRequestRecoveryAdmin = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-TwoFactorRequestRecoveryAdmin" */'./components/TwoFactorRequestRecovery/TwoFactorRequestRecoveryAdmin').catch(AsyncComponentErrorHandler('chunk-TwoFactorRequestRecoveryAdmin')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const LoginLinkInfoPageVariant = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-LoginLinkInfoPageVariant" */'./components/ConfirmToLogin/LoginLinkInfoPageVariant').catch(AsyncComponentErrorHandler('chunk-LoginLinkInfoPageVariant')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const ConfirmToLoginPageVariant = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-ConfirmToLoginPageVariant" */'./components/ConfirmToLogin/ConfirmToLoginPageVariant').catch(AsyncComponentErrorHandler('chunk-ConfirmToLoginPageVariant')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
const VettingPage = Loadable({
  loader: () => import( /* webpackChunkName: "chunk-VettingPage" */'./components/VettingPage').then(m => m.default).catch(AsyncComponentErrorHandler('chunk-VettingPage')),
  LoadingComponent: AsyncComponentLoading,
  ErrorComponent: AsyncComponentLoading
});
export const LoginRoutes = () => {
  const isMobileLoginReauthResult = useMobileReauthCookie();
  const isMobileLogin = isMobileLoginReauthResult || Boolean(getReauthCookieValue());
  const isUngatedForLoginV4 = useMemo(() => getIsUngatedForLoginV4(), []);
  const conditionalRoutes = useMemo(() => {
    return isUngatedForLoginV4 || isMobileLogin ? [/*#__PURE__*/_jsx(Route, {
      component: Login,
      exact: true,
      path: ['/', '/chatspot', '/connect']
    }, "v4-login-route"), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/two-factor",
      render: routeProps => /*#__PURE__*/_jsx(TwoFactorAuthPage, Object.assign({}, routeProps, {
        route: {
          name: 'twoFactorAuth'
        },
        isUngatedForLoginV4: true
      }))
    }, "v4-two-factor-route"), /*#__PURE__*/_jsx(Route, {
      component: RequestResetEmailPageVariant,
      exact: true,
      path: ['/forgot', '/password-leak', '/suspicious-activity', '/anomalous-login', '/idle-user']
    }, "ab-test-forgot-route"), /*#__PURE__*/_jsx(Route, {
      component: PasswordResetPageVariant,
      exact: true,
      path: "/passwordReset"
    }, "ab-test-password-reset-route"), /*#__PURE__*/_jsx(Route, {
      component: ConfirmToLoginPageVariant,
      exact: true,
      path: "/confirm-to-login"
    }, "ab-test-confirm-to-login-page-variant-route"), /*#__PURE__*/_jsx(Route, {
      component: LoginLinkInfoPageVariant,
      exact: true,
      path: "/confirm-to-login/login-link"
    }, "ab-test-login-link-info-page-variant-route"), /*#__PURE__*/_jsx(Route, {
      component: TwoFactorRequestRecoveryAdmin,
      exact: true,
      path: "/two-factor/recovery"
    }, "ab-test-two-factor-request-recovery-admin-route"), /*#__PURE__*/_jsx(Route, {
      exact: true,
      path: "/legacy",
      children: /*#__PURE__*/_jsx(Redirect, {
        to: "/"
      })
    }, "legacy-login-route-redirect")] : [];
  }, [isUngatedForLoginV4, isMobileLogin]);
  return /*#__PURE__*/_jsx(MobileLoginContext.Provider, {
    value: isMobileLogin,
    children: /*#__PURE__*/_jsxs(Switch, {
      children: [conditionalRoutes, /*#__PURE__*/_jsx(Route, {
        component: TwoFactorRequestRecoveryNametag,
        exact: true,
        path: "/two-factor/support-recovery"
      }), /*#__PURE__*/_jsx(Route, {
        path: "/vetting",
        render: props => /*#__PURE__*/_jsx(VettingPage, Object.assign({}, props, {
          route: {
            name: 'vetting'
          }
        }))
      }), /*#__PURE__*/_jsx(Route, {
        path: "*",
        render: ({
          location
        }) => /*#__PURE__*/_jsx(LegacyRoutes, {
          location: location,
          isMobileLogin: isMobileLogin
        })
      })]
    })
  });
};